<template>
    <div class="flex items-center ml-auto mr-8 lg:ml-0 lg:mr-0 md:ml-0 md:mr-2">
        <input @keyup.enter="search.searchClick" v-model="search.query.value" class="pr-2.5 pl-5 h-6 rounded-l-full w-52 lg:w-48 text-sm text-gray-900 md:hidden" type="text" placeholder="cursus zoeken">
        <button @click="search.searchClick" class="rounded-r-full h-6 ml-1 px-2 md:ml-0 md:bg-transparent md:rounded-none" :class="searchicon">
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
        </button>
    </div>
</template>

<script setup>
    const search = useSearch();
    const pathTools = usePathTools();

    const props = defineProps({
        frontpage: {
            type: Boolean,
            default: false,
        },
    })

    const searchicon = computed(() => {
        if (pathTools.inTko())
            return 'bg-gray-600'
        //else if (props.frontpage)
        //    return 'bg-ijsdonker'
        else
            return 'bg-ijsdonker'
    });

</script>
